bookingApp.directive('skBranding', function(){
    return {
        template: 'Powered by \
                    <a href="http://web.seekom.com" target="brandingwindow" title="Seekom iBex is a online booking and property management system for the accommodation market."> \
                        Seekom iBex \
                    </a> <br><br> <a href="https://www.seekom.com/about/privacy-policy" target="privacypolicy" title="iBex Privacy Policy" class="privacy-policy">Privacy Policy</a>'
    }
});